export function redirectToPdf(data, filename = 'downloaded') {
  if (data?.success) {
    const pdfLink = data.data;

    // Check if it's an iOS device
    const isIOS = /iPad|iPhone/i.test(window.navigator.userAgent);

    // Open PDF in a new tab/window for iOS devices
    if (isIOS) {
      window.open(pdfLink, '_blank');
    } else {
      // For other devices, create a link and trigger a download
      const link = document.createElement('a');
      link.href = pdfLink;
      link.target = '_blank';
      link.download = filename + '.pdf'; // Set a default filename for non-iOS devices
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(pdfLink);
      }, 100);
    }
  }
}

// TODO: Compare with redirectToPdf and merge
export const redirectToPdfV2 = (data) => {
  if (data?.success) {
    const pdfLink = data.data;
    const link = document.createElement('a');
    if (
      window.navigator.userAgent.match(/iPad/i) ||
      window.navigator.userAgent.match(/iPhone/i)
    ) {
      link.href = pdfLink;
    } else {
      link.href = pdfLink;
      link.target = '_blank';
    }
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(pdfLink);
    }, 100);
  }
};
